var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-tim-item"},[_c('div',{staticClass:"ui-tim-title-wrap"},[_vm._t("title"),_c('div',{staticClass:"ui-tim-img-wrap"},[_c('img',{staticClass:"ui-tim-img",attrs:{"src":_vm.ImageSrc,"alt":""}})])],2),_c('div',{staticClass:"ui-tim-text-wrap"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }